import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMPANY } from '../../data/content';

export default function Footer() {
  const { t } = useTranslation();
  const links = [
    { to: '/', key: 'home' },
    { to: '/about', key: 'about' },
    { to: '/portfolio', key: 'portfolio' },
    { to: '/leadership', key: 'leadership' },
    { to: '/insights', key: 'insights' },
    { to: '/contact', key: 'contact' },
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#EBE3D0] pt-24 pb-12 px-6 md:px-12 border-t border-[#0B1F3F]/10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24 relative z-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-5 mb-8">
              <img src={COMPANY.markWhite} alt={COMPANY.fullName} className="h-20 w-auto drop-shadow-[0_0_24px_rgba(196,46,44,0.35)]" />
              <div className="leading-tight">
                <p className="font-serif text-lg tracking-[0.15em] uppercase text-[#0B1F3F]">{t('company.short')}</p>
                <p className="text-[10px] tracking-[0.35em] uppercase text-[#6B5B4A] mt-1">{t('company.capital_ag')}</p>
              </div>
            </div>
            <h3 className="font-serif text-2xl md:text-3xl text-[#0B1F3F] leading-tight mb-6 max-w-md">
              {t('footer.tagline')}
            </h3>
            <p className="text-[#6B5B4A] font-sans text-sm max-w-md leading-relaxed">
              {t('footer.legal_note')}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#6B5B4A] mb-6">{t('footer.navigate')}</p>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.key}`}
                    className="text-[#0B1F3F] font-sans text-sm hover:text-[#B58F45] transition-colors"
                  >
                    {t(`nav.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#6B5B4A] mb-6">{t('footer.correspondence')}</p>
            <ul className="space-y-3 text-[#0B1F3F] font-sans text-sm">
              {COMPANY.addressLines.map((line) => (
                <li key={line}>{line}</li>
              ))}
              <li className="pt-3">
                <a href={`mailto:${COMPANY.contactEmail}`} className="hover:text-[#B58F45] transition-colors break-all" data-testid="footer-email">
                  {COMPANY.contactEmail}
                </a>
              </li>
              <li>
                <a href={`tel:${COMPANY.contactPhoneRaw}`} className="hover:text-[#B58F45] transition-colors" data-testid="footer-phone">
                  {COMPANY.contactPhone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div aria-hidden="true" className="select-none pointer-events-none">
          <div className="font-serif text-[10vw] md:text-[6vw] leading-[0.85] tracking-[0.02em] uppercase text-[#0B1F3F]/[0.06] text-center whitespace-nowrap overflow-hidden">
            De Almeda Seligmann
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-10 border-t border-[#0B1F3F]/10 relative z-10">
          <p className="text-xs text-[#6B5B4A] font-sans tracking-wide">
            © {new Date().getFullYear()} {t('footer.copyright_suffix')}
          </p>
          <div className="flex gap-6 text-xs text-[#6B5B4A] font-sans tracking-widest uppercase">
            <a href="#" className="hover:text-[#0B1F3F]">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-[#0B1F3F]">{t('footer.legal')}</a>
            <a href="#" className="hover:text-[#0B1F3F]">{t('footer.impressum')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
